import { __awaiter } from 'tslib';
import { IMNetApi, ConnectionStatus, NetworkType } from '../abstract/IMNetApi.js';

class BrowserNetApi extends IMNetApi {
    getConnectionStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof navigator !== 'undefined' && navigator.onLine !== undefined) {
                if (navigator.onLine) {
                    return ConnectionStatus.Connected;
                }
                else {
                    return ConnectionStatus.Disconnected;
                }
            }
            else {
                return ConnectionStatus.Unknown;
            }
        });
    }
    getNetworkType() {
        return __awaiter(this, void 0, void 0, function* () {
            const connected = yield this.getConnectionStatus();
            if (connected === ConnectionStatus.Disconnected) {
                return NetworkType.None;
            }
            // @ts-ignore
            if (typeof navigator !== 'undefined' && navigator.connection && navigator.connection.type) {
                // @ts-ignore
                switch (navigator.connection.type) {
                    case 'cellular':
                        // @ts-ignore
                        if (navigator.connection.effectiveType) {
                            // @ts-ignore
                            switch (navigator.connection.effectiveType) {
                                case '2g':
                                case 'slow-2g':
                                    return NetworkType.Cellular_2G;
                                case '3g':
                                    return NetworkType.Cellular_3G;
                                case '4g':
                                    return NetworkType.Cellular_4G;
                                case '5g':
                                    return NetworkType.Cellular_5G;
                                default:
                                    return NetworkType.Unknown;
                            }
                        }
                        else {
                            return NetworkType.Unknown;
                        }
                    case 'wifi':
                        return NetworkType.Wifi;
                    case 'other':
                        return NetworkType.Other;
                    case 'none':
                        return NetworkType.None;
                    default:
                        return NetworkType.Unknown;
                }
            }
            else {
                return NetworkType.Unknown;
            }
        });
    }
}

export { BrowserNetApi };
//# sourceMappingURL=BrowserNetApi.js.map
